import { useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Navbar } from '@/components/Navbar';
import { LandingPagesFooter as Footer } from '@podus/ui';
import { categories } from '@/components/help/data';
import HelpHero from '@/components/help/HelpHero';
import HelpSidebar from '@/components/help/HelpSidebar';
import FaqAccordion from '@/components/help/FaqAccordion';
import ContactContent from '@/components/help/ContactContent';
import TermsContent from '@/components/help/TermsContent';
import HowItWorksContent from '@/components/help/HowItWorksContent';
import ServiceCoverageContent from '@/components/help/ServiceCoverageContent';
import WhoPodusIsForContent from '@/components/help/WhoPodusIsForContent';
import FeaturesContent from '@/components/help/FeaturesContent';
import { generalFaqs } from '@/components/help/data';

const validCategories = categories.map((c) => c.id);

export default function HelpCenter() {
    const { category } = useParams<{ category: string }>();
    const navigate = useNavigate();
    const activeCategory = validCategories.includes(category ?? '') ? category! : 'contact';
    const [searchQuery, setSearchQuery] = useState('');

    const activeCat = categories.find((c) => c.id === activeCategory)!;
    const ActiveIcon = activeCat.icon;
    const fullPageCategories = ['terms', 'privacy', 'cookie-policy', 'how-it-works', 'service-coverage', 'who-podus-is-for', 'features'];
    const showIconHeader = !fullPageCategories.includes(activeCategory);

    const handleCategorySelect = (id: string) => {
        navigate(`/${id}`);
    };

    return (
        <div className="flex min-h-screen flex-col bg-background">
            <Navbar />
            <HelpHero searchQuery={searchQuery} onSearchChange={setSearchQuery} />
            <section className="flex-1 px-6 py-10 sm:px-10 lg:px-20 lg:py-16">
                <div className="mx-auto flex max-w-402.25 flex-col gap-6 lg:flex-row lg:gap-6.5">
                    <HelpSidebar activeCategory={activeCategory} onSelect={handleCategorySelect} />

                    <div className="min-w-0 flex-1">
                        {activeCategory === 'faqs' && <FaqAccordion faqs={generalFaqs} />}
                        {activeCategory === 'contact' && <ContactContent />}
                        {activeCategory === 'terms' && <TermsContent title="Terms & Condition" contentKey="terms" />}
                        {activeCategory === 'privacy' && <TermsContent title="Privacy Policy" contentKey="privacy" />}
                        {activeCategory === 'cookie-policy' && <TermsContent title="Cookie Policy" contentKey="cookie-policy" />}
                        {activeCategory === 'how-it-works' && <HowItWorksContent />}
                        {activeCategory === 'service-coverage' && <ServiceCoverageContent />}
                        {activeCategory === 'who-podus-is-for' && <WhoPodusIsForContent />}
                        {activeCategory === 'features' && <FeaturesContent />}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}
